import axios from '@/axios.js'
import network from '../../http/requests/network/index.js'

export default {
  fetchNetworks({ commit }) {
    return new Promise((resolve, reject) => {
      network
        .getNetworks()
        .then(response => {
          commit('SET_NETWORKS', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  addNetworkDomain({ commit }, { network_id, domain }) {
    return new Promise((resolve, reject) => {
      network
        .addNetworkDomain(network_id, domain)
        .then(response => {
          if (response.data.data) {
            commit('ADD_DOMAIN', response.data.data)
            resolve(response)
          } else {
            reject(response.data.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  updateNetworkDomain({ commit }, { network_id, domain_id, name, set, bac }) {
    return new Promise((resolve, reject) => {
      network
        .updateNetworkDomain(network_id, domain_id, name, set, bac)
        .then(response => {
          if (response.data.data) {
            commit('UPDATE_NETWORK_DOMAIN', response.data.data)
            resolve(response)
          } else {
            reject(response.data.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  fetchNetworkDomains({ commit }, network_id) {
    return new Promise((resolve, reject) => {
      network
        .getNetworkDomains(network_id)
        .then(response => {
          commit('SET_NETWORK_DOMAINS', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  fetchBackendSets({ commit }, network_id) {
    return new Promise((resolve, reject) => {
      network
        .getBackendSets(network_id)
        .then(response => {
          commit('SET_BACKEND_SETS', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  fetchBackendSetInfo({ commit }, { network_id, backend_set_id }) {
    return new Promise((resolve, reject) => {
      network
        .getBackendSetInfo(network_id, backend_set_id)
        .then(response => {
          commit('UPDATE_SELECTED_BACKEND_SET', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  updateBackendSet(
    { commit },
    { network_id, backend_set_id, name, backends, proxy_protocol, vulcan_ac_enabled, load_balancing_mode },
  ) {
    return new Promise((resolve, reject) => {
      network
        .updateBackendSet(
          network_id,
          backend_set_id,
          name,
          backends,
          proxy_protocol,
          vulcan_ac_enabled,
          load_balancing_mode
        )
        .then(response => {
          if (response.data) {
            commit('UPDATE_SELECTED_BACKEND_SET', {
              id: backend_set_id,
              name: name,
              backends: backends,
              proxy_protocol: proxy_protocol,
              vulcan_ac_enabled: vulcan_ac_enabled,
              load_balancing_mode: load_balancing_mode
            })
            resolve(response)
          } else {
            reject(response.data.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  deleteBackendSet({ commit }, { network_id, backend_set_id }) {
    return new Promise((resolve, reject) => {
      network
        .deleteBackendSet(network_id, backend_set_id)
        .then(response => {
          if (response.data) {
            resolve(response)
          } else {
            reject(response.data.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  createBackendSet({ commit }, { network_id, name, backends, proxy_protocol, vulcan_ac_enabled, load_balancing_mode}) {
    return new Promise((resolve, reject) => {
      network
        .createBackendSet(network_id, name, backends, proxy_protocol, vulcan_ac_enabled, load_balancing_mode)
        .then(response => {
          if (response.data.data) {
            commit('UPDATE_SELECTED_BACKEND_SET', response.data.data)
            resolve(response)
          } else {
            reject(response.data.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  createNetwork({ commit }, name) {
    return new Promise((resolve, reject) => {
      network
        .createNetwork(name)
        .then(response => {
          commit(
            'ADD_NETWORK',
            Object.assign(
              { name: name, id: response.data.network_id },
              { id: response.data.network_id },
            ),
          )
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  deleteDomain({ commit }, { network_id, domain }) {
    return new Promise((resolve, reject) => {
      network
        .deleteNetworkDomain(network_id, domain)
        .then(response => {
          commit('REMOVE_DOMAIN', domain)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateDomain({ commit }, { network_id, domain }) {
    return new Promise((resolve, reject) => {
      network
        .updateNetworkDomain(network_id, domain)
        .then(response => {
          commit('UPDATE_NETWORK_DOMAIN', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  verifyDomain({ commit }, { network_id, domain_id }) {
    return new Promise((resolve, reject) => {
      network
        .verifyDomain(network_id, domain_id)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  preVerifyDomain({}, { network_id, domain_name }) {
    return new Promise((resolve, reject) => {
      network
        .preVerifyDomain(network_id, domain_name)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchTunnels({ commit }, network_id) {
    return new Promise((resolve, reject) => {
      network
        .getTunnels(network_id)
        .then(response => {
          commit('SET_TUNNELS', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchTunnelLocations({ commit }, network_id) {
    return new Promise((resolve, reject) => {
      network
        .getTunnelLocations(network_id)
        .then(response => {
          commit('SET_TUNNEL_LOCATIONS', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  addTunnel({ commit }, { network_id, tunnel }) {
    return new Promise((resolve, reject) => {
      network
        .addTunnel(network_id, tunnel)
        .then(response => {
          if (response.data.data) {
            commit('ADD_TUNNEL', response.data.data)
            resolve(response)
          } else {
            reject(response.data.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateTunnel({ commit }, { network_id, tunnel }) {
    return new Promise((resolve, reject) => {
      network
        .updateTunnel(network_id, tunnel)
        .then(response => {
          if (response.data.data) {
            commit('UPDATE_TUNNEL', response.data.data)
            resolve(response)
          } else {
            reject(response.data.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteTunnel({ commit }, { network_id, entry_id }) {
    return new Promise((resolve, reject) => {
      network
        .deleteTunnel(network_id, entry_id)
        .then(response => {
          commit('REMOVE_TUNNEL', entry_id)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
